import GeneralLedgerAccountType from "@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountType";
import GeneralLedgerAccountState from "@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountState";

export default class CreateGeneralLedgerAccountRequest {
	name: string = '';
    code: number;
    currency: string = '';
    type: GeneralLedgerAccountType;
    state: GeneralLedgerAccountState = GeneralLedgerAccountState.Active;
}